import { copy } from "shared/assets";
import { IUserPermissions } from "shared/utils";
import { IStatus } from "shared/types";
import { IActionDropdownItem } from "shared/components";

const { actions: actionsCopy } = copy;

export const getInfoBlockItemActions = (
  userPermissions: IUserPermissions,
  openEditModal: () => void,
  openDeleteModal: () => void,
  infoBlockTitle?: string,
  unlinkItem?: () => void
): IActionDropdownItem[] => {
  const actions: IActionDropdownItem[] = [];

  if (userPermissions.EDIT) {
    actions.push({
      label: actionsCopy.edit,
      handleClick: openEditModal,
      dataTestId: "edit_info_block_item",
    });
    if (unlinkItem && infoBlockTitle) {
      actions.push({
        label: actionsCopy.removeFrom.replace("%s", infoBlockTitle),
        handleClick: unlinkItem,
        dataTestId: "unlink_info_block_item",
      });
    }
  }
  if (userPermissions.DELETE) {
    actions.push({
      label: actionsCopy.delete,
      status: IStatus.error,
      handleClick: openDeleteModal,
      dataTestId: "delete_info_block_item",
    });
  }

  return actions;
};
